import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { map, Observable } from 'rxjs';
import { EmployeeService } from '../services/employee-service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-apply-salaryadvance',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatIconModule
  ],
   providers: [DatePipe],
  templateUrl: './apply-salaryadvance.component.html',
  styleUrl: './apply-salaryadvance.component.css'
})
export class ApplySalaryadvanceComponent {
  salaryAdvanceRequestForm: FormGroup;
  isLoading = false;  
  holidayStatus$!: Observable<any[]>;
  empNo: string = '';
  constructor(private fb: FormBuilder, private employeeService: EmployeeService, private router: Router, private snackBar: MatSnackBar, private datePipe: DatePipe) {
    this.salaryAdvanceRequestForm = this.fb.group({
      amount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{0,2})?$/)]],
      reason: ['', Validators.required],
      return_date: ['', Validators.required]    
      // request_date: ['', Validators.required]
    });
    let code = sessionStorage.getItem("user_code");
    if (code && code.length > 0)
      this.empNo = code;
  }

  ngOnInit() {
    
  }
 
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (
      !/[0-9]/.test(event.key) &&
      !(event.key === '.' && !(event.target as HTMLInputElement).value.includes('.')) &&
      event.key !== 'Backspace' &&
      event.key !== 'Tab'
    ) {
      event.preventDefault();
    }
  }
  
  submitLeave() {    
    if (this.salaryAdvanceRequestForm.invalid) {
      this.salaryAdvanceRequestForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    
    const payload = {
      jsonrpc: '2.0',
      method: 'call',
      params: {
        return_date: this.datePipe.transform(this.salaryAdvanceRequestForm.value.return_date, 'yyyy-MM-dd'),
        request_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        amount: this.salaryAdvanceRequestForm.value.amount,
        reason: this.salaryAdvanceRequestForm.value.reason
      }
    };

    this.employeeService.applySalaryAdvance(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res && res.result && res.result.status == 200) {
          // this.router.navigate(['/registration-success', res.result.approval_id,'vendor']);
          this.snackBar.open('Salary advance requested successfully', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
        else {
          this.snackBar.open('Salary advance request failed, contact Accounts department', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.snackBar.open('Salary advance request failed, contact Accounts department', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      }
    });
  }
}
